module.exports = __webpack_public_path__ + "static/media/BlueFolder.abb8ff51.svg";